module.exports = __webpack_public_path__ + "img/erskine_t1.470b3fea.jpg";